import {
  BookOpen,
  ChevronDown,
  CircleQuestionMark,
  ExternalLink,
  MessageCircle,
  Phone,
} from "lucide-react"
import { MenuButton } from "shared-web/components/base/control/MenuButton"
import { popoverPanelAnchorEnd } from "shared-web/components/base/overlay/Popover/popoverStyles"
import { openTab } from "shared-web/lib/openTab"
import { toast } from "shared-web/lib/toast"

import { openIntercom } from "layouts/hooks/useIntercom"
import { supportNumber } from "lib/constants"
import { RUNDOCS_WELCOME } from "lib/rundocs"

export function SupportMenu() {
  return (
    <MenuButton
      mode="secondary"
      size="medium"
      leftIcon={CircleQuestionMark}
      rightIcon={ChevronDown}
      anchor={popoverPanelAnchorEnd}
      className="z-50 w-80"
      items={[
        {
          label: "Explore the Rundocs",
          icon: BookOpen,
          trailingIcon: ExternalLink,
          onClick: () => {
            openTab(RUNDOCS_WELCOME)
          },
        },
        {
          label: "Chat with support",
          icon: MessageCircle,
          onClick: openIntercom,
        },
        {
          label: "Support number",
          icon: Phone,
          trailingText: supportNumber(),
          onClick: () => {
            navigator.clipboard.writeText(supportNumber())
            toast.success({
              message: "Support phone number copied to clipboard",
            })
          },
        },
      ]}
    >
      Support
    </MenuButton>
  )
}
